"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectSubTypeMapper = exports.carbonAvoidanceSubTypeMapper = exports.ForestrySubType = exports.RenewablesSubType = void 0;
const project_types_1 = require("./project-types");
const projects_1 = require("./projects");
var RenewablesSubType;
(function (RenewablesSubType) {
    RenewablesSubType["Wind"] = "wind";
    RenewablesSubType["Solar"] = "solar";
    RenewablesSubType["Hydro"] = "hydro";
    RenewablesSubType["Biomass"] = "biomass";
})(RenewablesSubType = exports.RenewablesSubType || (exports.RenewablesSubType = {}));
var ForestrySubType;
(function (ForestrySubType) {
    ForestrySubType["ForestProtection"] = "forest_protection";
})(ForestrySubType = exports.ForestrySubType || (exports.ForestrySubType = {}));
exports.carbonAvoidanceSubTypeMapper = {
    [project_types_1.CarbonAvoidanceProjectType.All]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.None]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.Geothermal]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.Capture]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.Wetlands]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.Community]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.Transport]: undefined,
    [project_types_1.CarbonAvoidanceProjectType.Renewables]: RenewablesSubType,
    [project_types_1.CarbonAvoidanceProjectType.Forestry]: ForestrySubType,
};
exports.projectSubTypeMapper = {
    [projects_1.ProjectSelector.All]: {
        title: 'All',
        tag: projects_1.ProjectSelector.All,
    },
    [projects_1.ProjectSelector.None]: {
        title: 'None',
        tag: projects_1.ProjectSelector.None,
    },
    [RenewablesSubType.Wind]: {
        title: 'Renewables - Wind',
        tag: RenewablesSubType.Wind,
    },
    [RenewablesSubType.Solar]: {
        title: 'Renewables - Solar',
        tag: RenewablesSubType.Solar,
    },
    [RenewablesSubType.Hydro]: {
        title: 'Renewables - Hydro',
        tag: RenewablesSubType.Hydro,
    },
    [RenewablesSubType.Biomass]: {
        title: 'Renewables - Biomass',
        tag: RenewablesSubType.Biomass,
    },
    [ForestrySubType.ForestProtection]: {
        title: 'Forestry - Forest Protection',
        tag: ForestrySubType.ForestProtection,
    },
};
//# sourceMappingURL=data:application/json;base64,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